/**
 * Static geographic reference data for address field dropdowns.
 * Country list mirrors the backend `geocoding:countryOptions` handler.
 * State/province list mirrors the backend `geocoding:stateOptions` handler.
 */

export const GEO_COUNTRIES: string[] = [
  'United States',
  'United Kingdom',
  'Canada',
  'Australia',
  'Germany',
  'France',
  'Netherlands',
  'Sweden',
  'Norway',
  'Denmark',
  'Finland',
  'Switzerland',
  'Austria',
  'Belgium',
  'Ireland',
  'New Zealand',
  'Singapore',
  'Japan',
  'South Korea',
  'India',
  'Brazil',
  'Mexico',
  'Argentina',
  'Chile',
  'Colombia',
  'Spain',
  'Portugal',
  'Italy',
  'Poland',
  'Czech Republic',
  'Hungary',
  'Romania',
  'Ukraine',
  'Israel',
  'United Arab Emirates',
  'Saudi Arabia',
  'South Africa',
  'Nigeria',
  'Kenya',
  'Egypt',
  'China',
  'Hong Kong',
  'Taiwan',
  'Indonesia',
  'Malaysia',
  'Thailand',
  'Vietnam',
  'Philippines',
  'Pakistan',
  'Bangladesh',
  'Sri Lanka',
  'Afghanistan',
  'Iran',
  'Iraq',
  'Jordan',
  'Lebanon',
  'Qatar',
  'Kuwait',
  'Bahrain',
  'Oman',
  'Morocco',
  'Tunisia',
  'Algeria',
  'Ghana',
  'Ethiopia',
  'Tanzania',
  'Uganda',
  'Rwanda',
  'Senegal',
  'Ivory Coast',
  'Cameroon',
  'Mozambique',
  'Zimbabwe',
  'Zambia',
  'Botswana',
  'Namibia',
  'Angola',
  'Democratic Republic of the Congo',
  'Peru',
  'Ecuador',
  'Bolivia',
  'Paraguay',
  'Uruguay',
  'Venezuela',
  'Guatemala',
  'Honduras',
  'El Salvador',
  'Nicaragua',
  'Costa Rica',
  'Panama',
  'Cuba',
  'Dominican Republic',
  'Haiti',
  'Jamaica',
  'Trinidad and Tobago',
  'Barbados',
  'Bahamas',
  'Belize',
  'Guyana',
  'Suriname',
  'Iceland',
  'Luxembourg',
  'Malta',
  'Cyprus',
  'Estonia',
  'Latvia',
  'Lithuania',
  'Slovakia',
  'Slovenia',
  'Croatia',
  'Bosnia and Herzegovina',
  'Serbia',
  'Montenegro',
  'North Macedonia',
  'Albania',
  'Kosovo',
  'Moldova',
  'Belarus',
  'Georgia',
  'Armenia',
  'Azerbaijan',
  'Kazakhstan',
  'Uzbekistan',
  'Kyrgyzstan',
  'Turkmenistan',
  'Tajikistan',
  'Mongolia',
  'Nepal',
  'Bhutan',
  'Cambodia',
  'Laos',
  'Myanmar',
  'Brunei',
  'Papua New Guinea',
  'Fiji',
  'New Caledonia',
  'Mauritius',
  'Seychelles',
  'Maldives',
  'Other',
];

/** US states + territories + Canadian provinces. */
export const GEO_STATES: string[] = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
  'District of Columbia',
  'Puerto Rico',
  'Guam',
  'U.S. Virgin Islands',
  'Alberta',
  'British Columbia',
  'Manitoba',
  'New Brunswick',
  'Newfoundland and Labrador',
  'Nova Scotia',
  'Ontario',
  'Prince Edward Island',
  'Quebec',
  'Saskatchewan',
];
